import React from 'react';
import { PropTypes as PT } from 'prop-types';
import ContactItem from './ChatContactItem';
import classes from './ChatParticipants.module.scss';

const ChatParticipants = (props) => {
  const { contacts, emptyMessage } = props;

  return (
    <div>
      {contacts.length ? (
        <ul className={classes.participantList}>
          {contacts.map((contact, index) => (
            <ContactItem canRemove={false} canSelect={false} contact={contact} key={`participant-${index}`} />
          ))}
        </ul>
      ) : (
        <div>{emptyMessage}</div>
      )}
    </div>
  );
};

ChatParticipants.propTypes = {
  contacts: PT.array,
  emptyMessage: PT.oneOfType([PT.string, PT.element, PT.node, PT.object])
};

ChatParticipants.defaultProps = {
  contacts: [],
  emptyMessage: null
};

export default ChatParticipants;
